var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full md:max-w-[1440px] items-center",class:[_vm.defaultPadding ? _vm.padding : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }